(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5790],{

/***/ 50445:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hospitals/influenza",
      function () {
        return __webpack_require__(95910);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RefreshSVG */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89961);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  animation: ",
        " 0.5s linear;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var Refresh = function(param) {
    var _size = param.size, size = _size === void 0 ? 16 : _size, _color = param.color, color = _color === void 0 ? "black" : _color, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? 1.5 : _strokeWidth;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), rotation = ref[0], setRotation = ref[1];
    var onClick = function() {
        setRotation(true);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RefreshSVG, {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        rotation: rotation,
        onClick: onClick,
        onAnimationEnd: function() {
            return setRotation(false);
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
            d: "M11.5753 11.7697C10.8185 12.516 9.85398 13.0244 8.80386 13.2305C7.75373 13.4366 6.66515 13.3313 5.67581 12.9277C4.68648 12.5242 3.84083 11.8406 3.24586 10.9635C2.65089 10.0863 2.33331 9.05498 2.33331 7.99996C2.33331 6.94494 2.65089 5.91362 3.24586 5.03647C3.84083 4.15931 4.68648 3.47573 5.67581 3.07219C6.66515 2.66865 7.75373 2.56328 8.80386 2.76943C9.85398 2.97557 10.8185 3.48395 11.5753 4.23026L13.6666 6.28481M13.6666 6.28481V3.99996M13.6666 6.28481H11.3333",
            stroke: color,
            strokeWidth: strokeWidth,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Refresh);
var RefreshSVG = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].svg.withConfig */ .ZP.svg.withConfig({
    componentId: "sc-d319f18c-0"
})(_templateObject(), function(param) {
    var rotation = param.rotation;
    return rotation && rotateAnimation;
});
var rotate = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .keyframes */ .F4)(_templateObject1());
var rotateAnimation = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), rotate);


/***/ }),

/***/ 57971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var ArrowsButtonRightMin = function(param) {
    var _color = param.color, color = _color === void 0 ? "#8D9297" : _color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M5.2998 11.625L8.72168 8.28125L5.2998 4.95312L6.2373 4L10.6436 8.28125L6.2373 12.5781L5.2998 11.625Z",
            fill: color
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArrowsButtonRightMin);


/***/ }),

/***/ 12469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89961);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44376);
/* harmony import */ var _types_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70138);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  transition: transform 0.1s linear;\n  transform: rotate(\n    ",
        "deg\n  );\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




/**
 * @default
 * direction: DIRECTION.BOTTOM,
 * color: theme.color.gray900,
 * size: 16,
 */ var NarrowCaret = function(param) {
    var _direction = param.direction, direction = _direction === void 0 ? _types_common__WEBPACK_IMPORTED_MODULE_3__/* .DIRECTION.BOTTOM */ .JR.BOTTOM : _direction, _size = param.size, size = _size === void 0 ? 16 : _size, _color = param.color, color = _color === void 0 ? _styles_theme__WEBPACK_IMPORTED_MODULE_2__/* ["default"].color.gray900 */ .Z.color.gray900 : _color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CaretSVG, {
        width: size,
        height: size,
        direction: direction,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
            d: "M11.3594 5.40039L8.03125 8.82227L4.70312 5.40039L3.75 6.32227L8.03125 10.7285L12.3125 6.32227L11.3594 5.40039Z",
            fill: color
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NarrowCaret);
var CaretSVG = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].svg.withConfig */ .ZP.svg.withConfig({
    componentId: "sc-53b78b3d-0"
})(_templateObject(), function(param) {
    var direction = param.direction;
    return direction === _types_common__WEBPACK_IMPORTED_MODULE_3__/* .DIRECTION.TOP */ .JR.TOP ? -180 : direction === _types_common__WEBPACK_IMPORTED_MODULE_3__/* .DIRECTION.LEFT */ .JR.LEFT ? 90 : direction === _types_common__WEBPACK_IMPORTED_MODULE_3__/* .DIRECTION.RIGHT */ .JR.RIGHT ? -90 : 0;
});


/***/ }),

/***/ 37237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CF": function() { return /* binding */ AppHeaderLeftButtons; },
/* harmony export */   "Cr": function() { return /* binding */ LeftButton; },
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "P8": function() { return /* binding */ LeftButtonWrapper; },
/* harmony export */   "SL": function() { return /* binding */ AppHeaderWrapper; },
/* harmony export */   "iZ": function() { return /* binding */ AppHeaderContainer; },
/* harmony export */   "kR": function() { return /* binding */ AppHeaderRightButtons; },
/* harmony export */   "vV": function() { return /* binding */ AppHeaderExtendedWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89961);
/* harmony import */ var _components_atom_buttons_DefaultButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47641);
/* harmony import */ var _constants_zIndex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31591);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  z-index: ",
        ";\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  width: 100%;\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  max-width: ",
        ";\n  width: 100%;\n  height: ",
        ";\n  padding: 0 50px;\n  ",
        ";\n  ",
        ";\n  background-color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  overflow: hidden;\n  margin: 0;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 60px;\n  height: 100%;\n  left: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 28px;\n  height: 28px;\n  border-radius: 4px;\n  &:active {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  left: 16px;\n  button:last-child {\n    margin-left: 8px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  right: 16px;\n\n  button:last-child {\n    margin-left: 8px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var AppHeaderContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].header.withConfig */ .ZP.header.withConfig({
    componentId: "sc-6d7b0273-0"
})(_templateObject(), _constants_zIndex__WEBPACK_IMPORTED_MODULE_2__/* .zIndex.AppHeader */ .W.AppHeader, function(param) {
    var theme = param.theme;
    return "\n      background-color: ".concat(theme.color.white, ";\n    ");
});
var AppHeaderWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6d7b0273-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.size.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.size.appHeader.height;
}, function(param) {
    var left = param.left;
    return !left && "justify-content: center;";
}, function(param) {
    var left = param.left;
    return left && "padding-left: 18px";
}, function(param) {
    var theme = param.theme, color = param.color;
    return color ? color : theme.color.white;
});
var Title = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    componentId: "sc-6d7b0273-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI18SB, ";\n  ");
});
var LeftButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6d7b0273-3"
})(_templateObject3());
var LeftButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_components_atom_buttons_DefaultButton__WEBPACK_IMPORTED_MODULE_1__/* .DefaultButtonStyled */ .qY).withConfig({
    componentId: "sc-6d7b0273-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.color.gray50;
});
var AppHeaderLeftButtons = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6d7b0273-5"
})(_templateObject5());
var AppHeaderExtendedWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6d7b0273-6"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.size.tablet;
});
var AppHeaderRightButtons = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6d7b0273-7"
})(_templateObject7());


/***/ }),

/***/ 21128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89961);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44376);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 16px 24px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 16px 24px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  color: ",
        ";\n  white-space: pre-wrap;\n  text-align: center;\n  margin-top: 8px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  color: ",
        ";\n  background-color: ",
        ";\n  padding: 8px 16px;\n  margin-top: 16px;\n  border-radius: 8px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var EmptyNotice = function(param) {
    var icon = param.icon, text = param.text, buttonText = param.buttonText, onClick = param.onClick, _useButton = param.useButton, useButton = _useButton === void 0 ? true : _useButton;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Container, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
            children: [
                icon,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                    children: text
                }),
                useButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Button, {
                    onClick: onClick,
                    children: buttonText
                })
            ]
        })
    }, "empty-".concat(text));
};
/* harmony default export */ __webpack_exports__["Z"] = (EmptyNotice);
var Container = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-36fd5a31-0"
})(_templateObject());
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-36fd5a31-1"
})(_templateObject1());
var Text = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-36fd5a31-2"
})(_templateObject2(), _styles_theme__WEBPACK_IMPORTED_MODULE_3__/* ["default"].typography.UI16R */ .Z.typography.UI16R, _styles_theme__WEBPACK_IMPORTED_MODULE_3__/* ["default"].color.gray700 */ .Z.color.gray700);
var Button = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-36fd5a31-3"
})(_templateObject3(), _styles_theme__WEBPACK_IMPORTED_MODULE_3__/* ["default"].typography.UI16SB */ .Z.typography.UI16SB, _styles_theme__WEBPACK_IMPORTED_MODULE_3__/* ["default"].color.primary700 */ .Z.color.primary700, _styles_theme__WEBPACK_IMPORTED_MODULE_3__/* ["default"].color.primary100 */ .Z.color.primary100);


/***/ }),

/***/ 95392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53476);
/* harmony import */ var _hooks_useScreenFocus__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50341);
/* harmony import */ var _recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4415);
/* harmony import */ var _recoil_atoms_common_user__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3818);
/* harmony import */ var _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10712);






var useSetAuthOnScreenFocus = function() {
    var focused = (0,_hooks_useScreenFocus__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var setToken = (0,recoil__WEBPACK_IMPORTED_MODULE_1__.useSetRecoilState)(_recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_3__/* .tokenState */ .J1);
    var setUser = (0,recoil__WEBPACK_IMPORTED_MODULE_1__.useSetRecoilState)(_recoil_atoms_common_user__WEBPACK_IMPORTED_MODULE_4__/* .userState */ .KL);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_5__/* .isWebView */ .vp)()) {
            if (!(window === null || window === void 0 ? void 0 : window.appToken) || (window === null || window === void 0 ? void 0 : window.appToken) === "undefined") {
                setToken("");
            } else {
                setToken(window.appToken);
            }
            if (!(window === null || window === void 0 ? void 0 : window.appUser) || (window === null || window === void 0 ? void 0 : window.appUser) === "undefined") {
                setUser(undefined);
            } else {
                setUser(JSON.parse(window.appUser));
            }
        }
    }, [
        focused,
        setToken,
        setUser
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useSetAuthOnScreenFocus);


/***/ }),

/***/ 95910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ influenza; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/tippy.js/dist/tippy.css
var tippy = __webpack_require__(39110);
// EXTERNAL MODULE: ./src/components/layouts/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(83651);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/atom/MaterialIcon.tsx
var MaterialIcon = __webpack_require__(17986);
// EXTERNAL MODULE: ./src/components/atom/icon/Refresh.tsx
var Refresh = __webpack_require__(19875);
// EXTERNAL MODULE: ./src/components/common/ClickEventLogger.tsx
var ClickEventLogger = __webpack_require__(9558);
// EXTERNAL MODULE: ./src/components/common/link-tag/index.tsx
var link_tag = __webpack_require__(1967);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/components/templates/f2f/common/hospital-list/index.tsx
var hospital_list = __webpack_require__(77899);
// EXTERNAL MODULE: ./src/components/templates/f2f/common/hospital-region-filter-modal/index.tsx
var hospital_region_filter_modal = __webpack_require__(99332);
// EXTERNAL MODULE: ./src/components/templates/f2f/hospital/empty-notice/index.tsx
var empty_notice = __webpack_require__(21128);
// EXTERNAL MODULE: ./src/components/templates/mobile/f2f/hospital/hospitals-mobile-template/sticky-move-top-button/index.tsx + 1 modules
var sticky_move_top_button = __webpack_require__(39227);
// EXTERNAL MODULE: ./src/hooks/auth/useSetAuthOnScreenFocus.tsx
var useSetAuthOnScreenFocus = __webpack_require__(95392);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/lodash/find.js
var find = __webpack_require__(55281);
var find_default = /*#__PURE__*/__webpack_require__.n(find);
// EXTERNAL MODULE: ../../node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(45455);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ../../node_modules/lodash/toNumber.js
var toNumber = __webpack_require__(7642);
var toNumber_default = /*#__PURE__*/__webpack_require__.n(toNumber);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./src/parsers/f2f/common/index.ts
var common = __webpack_require__(89325);
// EXTERNAL MODULE: ./src/types/hospital.ts
var hospital = __webpack_require__(24396);
;// CONCATENATED MODULE: ./src/hooks/hospital/list/useInfluenzaHospitalFilters.ts






var useInfluenzaHospitalFilters = function() {
    var ref = (0,react.useState)((0,common/* initializeSelectedInfluenzaFilters */.pO)()), selectedInfluenzaFilters = ref[0], setSelectedInfluenzaFilters = ref[1];
    var ref1 = (0,react.useState)((0,common/* initializeIsInfluenzaFiltersOpen */.sO)()), isInfluenzaFiltersOpen = ref1[0], setIsInfluenzaFiltersOpen = ref1[1];
    var freeInfluenzaFilters = Object.values(hospital/* HospitalFreeInfluenzaType */.Sy).map(function(type) {
        return new common/* FreeInfluenzaFilter */.TX(type);
    });
    var isFreeInfluenzaFilterSelected = !!selectedInfluenzaFilters.FreeInfluenza.type;
    var isInfluenzaFiltersSelected = Object.values(selectedInfluenzaFilters).some(function(filter) {
        return Boolean(filter.type);
    });
    var selectInfluenzaFilter = function(type) {
        return function(value) {
            setSelectedInfluenzaFilters((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedInfluenzaFilters), (0,_define_property/* default */.Z)({}, type, value)));
            toggleInfluenzaFilter(type)();
        };
    };
    var toggleInfluenzaFilter = function(type) {
        return function() {
            setIsInfluenzaFiltersOpen((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, isInfluenzaFiltersOpen), (0,_define_property/* default */.Z)({}, type, !isInfluenzaFiltersOpen[type])));
        };
    };
    var resetInfluenzaFilters = function() {
        setSelectedInfluenzaFilters((0,common/* initializeSelectedInfluenzaFilters */.pO)());
    };
    var getFreeInfluenzaFiltersProps = function() {
        return {
            freeInfluenzaFilters: freeInfluenzaFilters,
            onClickFilter: selectInfluenzaFilter(hospital/* HospitalInfluenzaFilter.FreeInfluenza */.rT.FreeInfluenza),
            selectedFreeInfluenzaFilter: selectedInfluenzaFilters.FreeInfluenza,
            closeBottomSheet: toggleInfluenzaFilter(hospital/* HospitalInfluenzaFilter.FreeInfluenza */.rT.FreeInfluenza)
        };
    };
    return {
        selectedInfluenzaFilters: selectedInfluenzaFilters,
        isInfluenzaFiltersOpen: isInfluenzaFiltersOpen,
        isInfluenzaFiltersSelected: isInfluenzaFiltersSelected,
        freeInfluenzaFilters: freeInfluenzaFilters,
        isFreeInfluenzaFilterSelected: isFreeInfluenzaFilterSelected,
        selectInfluenzaFilter: selectInfluenzaFilter,
        toggleInfluenzaFilter: toggleInfluenzaFilter,
        resetInfluenzaFilters: resetInfluenzaFilters,
        getFreeInfluenzaFiltersProps: getFreeInfluenzaFiltersProps
    };
};
/* harmony default export */ var list_useInfluenzaHospitalFilters = (useInfluenzaHospitalFilters);

// EXTERNAL MODULE: ./src/recoil/atoms/common/auth.ts
var auth = __webpack_require__(4415);
// EXTERNAL MODULE: ./src/services/hospital/SearchHospitalService.ts
var SearchHospitalService = __webpack_require__(23144);
// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
// EXTERNAL MODULE: ./src/types/common.ts
var types_common = __webpack_require__(70138);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
// EXTERNAL MODULE: ./src/hooks/useScreenFocus.tsx
var useScreenFocus = __webpack_require__(50341);
// EXTERNAL MODULE: ./src/hooks/useToast.tsx
var useToast = __webpack_require__(17722);
// EXTERNAL MODULE: ./src/hooks/hospital/search/useGetAddressToCoordinateByIp.ts
var useGetAddressToCoordinateByIp = __webpack_require__(49626);
// EXTERNAL MODULE: ./src/hooks/hospital/search/useGetUserAddressByLocation.ts
var useGetUserAddressByLocation = __webpack_require__(77688);
// EXTERNAL MODULE: ./src/hooks/hospital/search/useGetUserAddresses.ts
var useGetUserAddresses = __webpack_require__(63983);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs + 1 modules
var useInfiniteQuery = __webpack_require__(59403);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(4611);
// EXTERNAL MODULE: ./src/hooks/hospital/search/f2fSearch.gql.impl.tsx
var f2fSearch_gql_impl = __webpack_require__(42225);
;// CONCATENATED MODULE: ./src/hooks/hospital/search/useSearchInfluenzaHospitalsInfinityQuery.ts












var parseInfluenzaHospitalByKeywordVo = function(data) {
    var _hospitalRepresentativeDepartmentName, ref, ref1, ref2, ref3;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
        pages: data.pages.map(function(page) {
            var ref4;
            return (ref3 = (ref4 = page.searchInfluenzaHospitals) === null || ref4 === void 0 ? void 0 : ref4.elements.map(function(hospital) {
                var ref3, ref4, ref5;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hospital), {
                    hospitalRepresentativeDepartmentName: (_hospitalRepresentativeDepartmentName = hospital.hospitalRepresentativeDepartmentName) !== null && _hospitalRepresentativeDepartmentName !== void 0 ? _hospitalRepresentativeDepartmentName : "",
                    hospitalTotalCount: (ref = (ref3 = page.searchInfluenzaHospitals) === null || ref3 === void 0 ? void 0 : ref3.totalCount) !== null && ref !== void 0 ? ref : 0,
                    reviewScore: (0,format/* getReviewScore */.ds)(hospital.reviewAverageRating),
                    reviewCount: (0,format/* getFormattedReviewTotalCount */.G9)(hospital.reviewTotalCount),
                    hospitalOperationStatus: (0,format/* getDiagnosisStateOfOperatingStatus */.PT)(hospital.hospitalOperationStatus),
                    nonBenefit: {
                        diagnosisPrice: (ref1 = Number((ref4 = hospital.influenzaPriceWithMetadata) === null || ref4 === void 0 ? void 0 : ref4.diagnosisPrice)) !== null && ref1 !== void 0 ? ref1 : 0,
                        labels: (ref2 = (ref5 = hospital.influenzaPriceWithMetadata) === null || ref5 === void 0 ? void 0 : ref5.labels) !== null && ref2 !== void 0 ? ref2 : []
                    },
                    doctors: []
                });
            })) !== null && ref3 !== void 0 ? ref3 : [];
        })
    });
};
var DEFAULT_SIZE = 30;
var useSearchInfluenzaHospitalsInfinityQuery = function(request) {
    var ref;
    var limit = request.limit || DEFAULT_SIZE;
    var infinityQuery = (0,useInfiniteQuery/* useInfiniteQuery */.N)(f2fSearch_gql_impl/* useSearchInfluenzaHospitalsQuery.getKey */.Od.getKey({
        request: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, request), {
            limit: limit
        })
    }), function(param) {
        var pageParam = param.pageParam;
        return f2fSearch_gql_impl/* useSearchInfluenzaHospitalsQuery.fetcher */.Od.fetcher({
            request: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, request), {
                limit: limit,
                pivotId: pageParam === null || pageParam === void 0 ? void 0 : pageParam.pivot,
                pivotScore: pageParam === null || pageParam === void 0 ? void 0 : pageParam.pivotScore
            })
        })();
    }, {
        select: parseInfluenzaHospitalByKeywordVo,
        getNextPageParam: function(lastPage) {
            var ref, ref1, ref2;
            var limit = request.limit || DEFAULT_SIZE;
            var _length;
            var lastPageLength = (_length = (ref = lastPage.searchInfluenzaHospitals) === null || ref === void 0 ? void 0 : ref.elements.length) !== null && _length !== void 0 ? _length : 0;
            if (lastPageLength < limit) {
                return undefined;
            }
            var nextPivotId = Number((ref1 = lastPage.searchInfluenzaHospitals) === null || ref1 === void 0 ? void 0 : ref1.pivot);
            var nextPivotScore = Number((ref2 = lastPage.searchInfluenzaHospitals) === null || ref2 === void 0 ? void 0 : ref2.pivotScore);
            return {
                pivot: nextPivotId,
                pivotScore: nextPivotScore
            };
        }
    });
    var ref1;
    var hospitals = (ref1 = (ref = infinityQuery.data) === null || ref === void 0 ? void 0 : ref.pages.flatMap(function(hospital) {
        return hospital;
    })) !== null && ref1 !== void 0 ? ref1 : [];
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infinityQuery), {
        data: hospitals
    });
};
/* harmony default export */ var search_useSearchInfluenzaHospitalsInfinityQuery = (useSearchInfluenzaHospitalsInfinityQuery);
useSearchInfluenzaHospitalsInfinityQuery.prefetchQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient, queries) {
        var queryParams;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    queryParams = {
                        geoPoint: getCoordinate(),
                        limit: DEFAULT_SIZE,
                        sortType: gql_schema/* HospitalSortType.Distance */.BBh.Distance,
                        regionByDepth: getRegionByQuery(queries)
                    };
                    return [
                        4,
                        queryClient.prefetchInfiniteQuery(f2fSearch_gql_impl/* useSearchInfluenzaHospitalsQuery.getKey */.Od.getKey({
                            request: queryParams
                        }), f2fSearch_gql_impl/* useSearchInfluenzaHospitalsQuery.fetcher */.Od.fetcher({
                            request: queryParams
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(queryClient, queries) {
        return _ref.apply(this, arguments);
    };
}();
var getCoordinate = function(queryLatitude, queryLongitude) {
    if (!queryLatitude || !queryLongitude) {
        return SearchHospitalService/* SearchHospitalService.initializeUserCoordinate */.h.initializeUserCoordinate();
    }
    var latitude = toNumber_default()(queryLatitude);
    var longitude = toNumber_default()(queryLongitude);
    if (isNaN(latitude) || isNaN(longitude)) {
        return SearchHospitalService/* SearchHospitalService.initializeUserCoordinate */.h.initializeUserCoordinate();
    }
    return {
        latitude: latitude,
        longitude: longitude
    };
};
var getRegionByQuery = function(queries) {
    if (!(queries === null || queries === void 0 ? void 0 : queries.siDoName)) {
        return undefined;
    }
    var ref;
    return {
        legalEupMyeonDongName: queries === null || queries === void 0 ? void 0 : queries.legalEupMyeonDongName,
        siGunGuName: queries === null || queries === void 0 ? void 0 : queries.siGunGuName,
        siDoName: (ref = queries === null || queries === void 0 ? void 0 : queries.siDoName) !== null && ref !== void 0 ? ref : ""
    };
};

// EXTERNAL MODULE: ./src/hooks/hospital/search/useSearchKoreaAddressV2.ts
var useSearchKoreaAddressV2 = __webpack_require__(75527);
;// CONCATENATED MODULE: ./src/hooks/hospital/list/useInfluenzaHospitalListViewModel.ts















// eslint-disable-next-line import/order






var useInfluenzaHospitalListViewModel = function() {
    var ref, ref1, ref2, ref3, ref4;
    var router = (0,next_router.useRouter)();
    var pageName = (0,logger/* getPageName */.j0)(router);
    var showToast = (0,useToast/* default */.Z)().showToast;
    var isFocused = (0,useScreenFocus/* default */.Z)();
    var queries = router.query;
    var isLoggedIn = !!(0,auth/* getAuthToken */.bW)();
    var ref5 = (0,useGetAddressToCoordinateByIp/* default */.Z)(), userCoordinateByIp = ref5.data;
    var initialCoord = (0,react.useMemo)(function() {
        var initialCoordinate = SearchHospitalService/* SearchHospitalService.initializeUserCoordinate */.h.initializeUserCoordinate();
        if (!userCoordinateByIp) {
            return (0,_object_spread/* default */.Z)({}, initialCoordinate);
        }
        var latitude = toNumber_default()(initialCoordinate.latitude);
        var longitude = toNumber_default()(initialCoordinate.longitude);
        if (isNaN(latitude) || isNaN(longitude)) {
            return (0,_object_spread/* default */.Z)({}, initialCoordinate);
        }
        return {
            latitude: latitude,
            longitude: longitude
        };
    }, [
        userCoordinateByIp
    ]);
    var ref6 = (0,react.useState)(initialCoord), coordinate = ref6[0], setCoordinate = ref6[1];
    var ref7 = (0,react.useState)(false), isRegionFilterOpened = ref7[0], setIsRegionFilterOpened = ref7[1];
    var ref8 = (0,react.useState)({
        siDo: null,
        siGunGu: null,
        dong: null
    }), selectedRegion = ref8[0], setSelectedRegion = ref8[1];
    var ref9 = (0,react.useState)(queries), regionByDepth = ref9[0], setRegionByDepth = ref9[1];
    var isSejong = ((ref = selectedRegion.siDo) === null || ref === void 0 ? void 0 : ref.regionCode) === "36";
    var ref10 = (0,useSearchKoreaAddressV2/* default */.Z)({
        siDoCode: null,
        siGunGuCode: null
    }), tmp = ref10.data, siDoList = tmp === void 0 ? [] : tmp;
    var ref11 = (0,useSearchKoreaAddressV2/* default */.Z)({
        siDoCode: isSejong ? "" : ((ref1 = selectedRegion.siDo) === null || ref1 === void 0 ? void 0 : ref1.regionCode) || "",
        siGunGuCode: null
    }), tmp1 = ref11.data, siGunGuList = tmp1 === void 0 ? [] : tmp1;
    var ref12 = (0,useSearchKoreaAddressV2/* default */.Z)({
        siDoCode: ((ref2 = selectedRegion.siDo) === null || ref2 === void 0 ? void 0 : ref2.regionCode) || "",
        siGunGuCode: isSejong ? null : ((ref3 = selectedRegion.siGunGu) === null || ref3 === void 0 ? void 0 : ref3.regionCode) || ""
    }), tmp2 = ref12.data, dongList = tmp2 === void 0 ? [] : tmp2;
    var ref13 = (0,useGetUserAddressByLocation/* default */.Z)(coordinate.latitude, coordinate.longitude), tmp3 = ref13.data, sigunguDongli = tmp3 === void 0 ? SearchHospitalService/* SearchHospitalService.initializeUserSigunguDongli */.h.initializeUserSigunguDongli() : tmp3, addressFetch = ref13.refetch;
    var influenzaHospitalFilterHook = list_useInfluenzaHospitalFilters();
    var selectedInfluenzaFilters = influenzaHospitalFilterHook.selectedInfluenzaFilters;
    var searchHospitalsParams = (0,react.useMemo)(function() {
        return {
            geoPoint: coordinate,
            limit: 30,
            sortType: gql_schema/* HospitalSortType.Distance */.BBh.Distance,
            freeVaccinationFilters: selectedInfluenzaFilters.FreeInfluenza.dtoType ? [
                selectedInfluenzaFilters.FreeInfluenza.dtoType
            ] : undefined
        };
    }, [
        coordinate,
        selectedInfluenzaFilters.FreeInfluenza
    ]);
    var getSearchHospitalsParams = (0,react.useCallback)(function() {
        if (!(regionByDepth === null || regionByDepth === void 0 ? void 0 : regionByDepth.siDoName)) {
            return searchHospitalsParams;
        }
        var ref;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchHospitalsParams), {
            regionByDepth: {
                legalEupMyeonDongName: regionByDepth === null || regionByDepth === void 0 ? void 0 : regionByDepth.legalEupMyeonDongName,
                siGunGuName: regionByDepth === null || regionByDepth === void 0 ? void 0 : regionByDepth.siGunGuName,
                siDoName: (ref = regionByDepth === null || regionByDepth === void 0 ? void 0 : regionByDepth.siDoName) !== null && ref !== void 0 ? ref : ""
            }
        });
    }, [
        regionByDepth,
        searchHospitalsParams
    ]);
    var searchHospitalsQuery = search_useSearchInfluenzaHospitalsInfinityQuery((0,_object_spread/* default */.Z)({}, getSearchHospitalsParams()));
    var ref14 = (0,useGetUserAddresses/* default */.Z)(), addresses = ref14.data, refetchAddresses = ref14.refetch;
    var updateCoordinate = function(coord) {
        initRegionFilter();
        return setCoordinate(function(prev) {
            return SearchHospitalService/* SearchHospitalService.updateCoordinate */.h.updateCoordinate(prev, coord);
        });
    };
    var updatePureCoordinate = function(coord) {
        return setCoordinate(function(prev) {
            return SearchHospitalService/* SearchHospitalService.updateCoordinate */.h.updateCoordinate(prev, coord);
        });
    };
    var getHeaderAddress = function() {
        var address = "".concat(sigunguDongli.sigungu, " ").concat(sigunguDongli.dongLi);
        if (regionByDepth === null || regionByDepth === void 0 ? void 0 : regionByDepth.siDoName) {
            if (!regionByDepth.siGunGuName && !regionByDepth.legalEupMyeonDongName) {
                address = "".concat(regionByDepth.siDoName);
            } else if (regionByDepth.siGunGuName && !regionByDepth.legalEupMyeonDongName) {
                address = "".concat(regionByDepth.siDoName, " ").concat(regionByDepth.siGunGuName);
            } else if (regionByDepth.siGunGuName && regionByDepth.legalEupMyeonDongName) {
                address = "".concat(regionByDepth.siGunGuName, " ").concat(regionByDepth.legalEupMyeonDongName);
            } else if (!regionByDepth.siGunGuName && regionByDepth.legalEupMyeonDongName) {
                address = "".concat(regionByDepth.siDoName, " ").concat(regionByDepth.legalEupMyeonDongName);
            }
        }
        return address;
    };
    var switchRegionFilter = function() {
        // 지역필터 모달 오픈시
        if (!isRegionFilterOpened) {
            (0,logger/* faceTofaceLogger */.vS)({
                pageName: pageName,
                eventName: "click_region_filter"
            });
        }
        setIsRegionFilterOpened(!isRegionFilterOpened);
    };
    var selectRegion = function(region) {
        setRegionByDepth({
            siDoName: region.siDoName,
            siGunGuName: region === null || region === void 0 ? void 0 : region.siGunGuName,
            legalEupMyeonDongName: region === null || region === void 0 ? void 0 : region.dongName
        });
        setIsRegionFilterOpened(false);
    };
    var changeSiDo = function(siDo, isAll) {
        setSelectedRegion({
            siDo: siDo,
            siGunGu: null,
            dong: null
        });
        if (isAll) {
            selectRegion({
                siDoName: siDo.regionName,
                siGunGuName: undefined,
                dongName: undefined
            });
        }
    };
    var clickSiDo = function(item, isAll) {
        return function(event) {
            (0,logger/* faceTofaceLogger */.vS)({
                pageName: pageName,
                eventName: "click_region_filter_find",
                payload: {
                    sector_1: item.regionName
                }
            });
            event.stopPropagation();
            changeSiDo(item, isAll);
        };
    };
    var changeSiGunGu = function(siGunGu, isAll) {
        var ref;
        if (!(selectedRegion === null || selectedRegion === void 0 ? void 0 : selectedRegion.siDo)) {
            return;
        }
        if (!isAll && siGunGu.regionCode === ((ref = selectedRegion.siGunGu) === null || ref === void 0 ? void 0 : ref.regionCode)) {
            setSelectedRegion((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedRegion), {
                siGunGu: null,
                dong: null
            }));
            return;
        }
        setSelectedRegion((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedRegion), {
            siGunGu: siGunGu,
            dong: null
        }));
        if (isAll) {
            selectRegion({
                siDoName: selectedRegion.siDo.regionName,
                siGunGuName: siGunGu.regionName
            });
        }
    };
    var clickSiGunGu = function(item, isAll) {
        return function(event) {
            var ref;
            var ref1;
            (0,logger/* faceTofaceLogger */.vS)({
                pageName: pageName,
                eventName: "click_region_filter_find",
                payload: {
                    sector_1: (ref1 = (ref = selectedRegion.siDo) === null || ref === void 0 ? void 0 : ref.regionName) !== null && ref1 !== void 0 ? ref1 : "",
                    sector_2: item.regionName
                }
            });
            event.stopPropagation();
            changeSiGunGu(item, isAll);
        };
    };
    var changeDong = function(dong) {
        var ref;
        if (!dong.regionCode || !selectedRegion.siDo) return;
        setSelectedRegion((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedRegion), {
            dong: dong
        }));
        selectRegion({
            siDoName: selectedRegion.siDo.regionName,
            siGunGuName: (ref = selectedRegion.siGunGu) === null || ref === void 0 ? void 0 : ref.regionName,
            dongName: dong === null || dong === void 0 ? void 0 : dong.regionName
        });
    };
    var clickDong = function(item) {
        return function(event) {
            var ref, ref1;
            var ref2, ref3;
            (0,logger/* faceTofaceLogger */.vS)({
                pageName: pageName,
                eventName: "click_region_filter_find",
                payload: {
                    sector_1: (ref2 = (ref = selectedRegion.siDo) === null || ref === void 0 ? void 0 : ref.regionName) !== null && ref2 !== void 0 ? ref2 : "",
                    sector_2: (ref3 = (ref1 = selectedRegion.siGunGu) === null || ref1 === void 0 ? void 0 : ref1.regionName) !== null && ref3 !== void 0 ? ref3 : "",
                    sector_3: item.regionName
                }
            });
            event.stopPropagation();
            changeDong(item);
        };
    };
    var initRegionFilter = function() {
        setSelectedRegion({
            siDo: null,
            siGunGu: null,
            dong: null
        });
        setRegionByDepth({});
    };
    var requestGeolocationPermission = (0,react.useCallback)(function() {
        initRegionFilter();
        if (!navigator.geolocation) {
            showToast({
                message: "다른 브라우저로 해당 기능을 이용해주세요"
            });
            updateCoordinate(initialCoord);
            return;
        }
        navigator.geolocation.getCurrentPosition(function(param) {
            var coords = param.coords;
            updateCoordinate({
                latitude: coords.latitude,
                longitude: coords.longitude
            });
        }, function() {
            showToast({
                message: "위치 사용을 허용을 해야 내 위치 설정이 가능해요"
            });
        }, {
            enableHighAccuracy: true
        });
    }, [
        initialCoord,
        showToast
    ]);
    var getCurrentLocation = function() {
        (0,logger/* faceTofaceLogger */.vS)({
            pageName: pageName,
            eventName: "click_region_filter_my_location"
        });
        requestGeolocationPermission();
        setIsRegionFilterOpened(false);
    };
    var goToAppHospital = function(hospitalPid) {
        if (!(0,RNPlugins/* isWebView */.vp)()) {
            return;
        }
        (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.MOVE_TO_PAGE */.nn.MOVE_TO_PAGE, {
            screenName: types_common/* ROUTES.HOSPITAL.DETAIL.appScreenName */.Z6.HOSPITAL.DETAIL.appScreenName,
            params: {
                hospitalPid: hospitalPid,
                type: "influenza"
            }
        });
    };
    var goToAppMyPageAddressScreen = function() {
        if (!(0,RNPlugins/* isWebView */.vp)()) {
            return;
        }
        (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.MOVE_TO_PAGE */.nn.MOVE_TO_PAGE, {
            screenName: "AddressStack",
            params: {
                screen: types_common/* ROUTES.ADDRESS.HOME.appScreenName */.Z6.ADDRESS.HOME.appScreenName
            }
        });
    };
    var selectSavedAddress = function(coordiname) {
        return function() {
            updateCoordinate(coordiname);
            switchRegionFilter();
        };
    };
    /**
   * queryDepartmentId 유무에 따라 초기 departmentId를 다르게 가져가기 위함
   */ (0,react.useEffect)(function() {
        if (!userCoordinateByIp) {
            return;
        }
        updatePureCoordinate(userCoordinateByIp);
    }, [
        userCoordinateByIp
    ]);
    (0,react.useEffect)(function() {
        if (isFocused && isLoggedIn) {
            refetchAddresses();
        }
    }, [
        isFocused,
        isLoggedIn
    ]);
    (0,react.useEffect)(function() {
        addressFetch();
    }, [
        coordinate,
        addressFetch
    ]);
    (0,react.useEffect)(function() {
        if (isRegionFilterOpened) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    }, [
        isRegionFilterOpened
    ]);
    (0,react.useEffect)(function() {
        if (!isEmpty_default()(siDoList) && !selectedRegion.siDo) {
            var seoul = find_default()(siDoList, {
                regionCode: "11"
            });
            if (seoul) {
                changeSiDo(seoul);
            }
        }
    }, [
        siDoList,
        selectedRegion.siDo
    ]);
    (0,react.useEffect)(function() {
        window.scrollTo({
            top: 0
        });
    }, [
        getSearchHospitalsParams()
    ]);
    var _data, _hasNextPage;
    return (0,_object_spread/* default */.Z)({
        goToAppHospital: goToAppHospital,
        goToAppMyPageAddressScreen: goToAppMyPageAddressScreen,
        selectSavedAddress: selectSavedAddress,
        hospitals: (_data = searchHospitalsQuery.data) !== null && _data !== void 0 ? _data : [],
        isLoadingHospitals: searchHospitalsQuery.isLoading,
        hasNoData: !((ref4 = searchHospitalsQuery.data) === null || ref4 === void 0 ? void 0 : ref4.length),
        updateCoordinate: updateCoordinate,
        fetchNextPage: searchHospitalsQuery.fetchNextPage,
        hasNextPage: (_hasNextPage = searchHospitalsQuery.hasNextPage) !== null && _hasNextPage !== void 0 ? _hasNextPage : false,
        requestGeolocationPermission: requestGeolocationPermission,
        addresses: addresses,
        switchRegionFilter: switchRegionFilter,
        isRegionFilterOpened: isRegionFilterOpened,
        siDoList: siDoList,
        siGunGuList: siGunGuList,
        dongList: dongList,
        changeSiDo: changeSiDo,
        regionByDepth: regionByDepth,
        getHeaderAddress: getHeaderAddress,
        selectedRegion: selectedRegion,
        getCurrentLocation: getCurrentLocation,
        clickSiDo: clickSiDo,
        clickSiGunGu: clickSiGunGu,
        clickDong: clickDong,
        isSejong: isSejong
    }, influenzaHospitalFilterHook);
};
/* harmony default export */ var list_useInfluenzaHospitalListViewModel = (useInfluenzaHospitalListViewModel);

// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/components/atom/images/DoctornowImage.tsx
var DoctornowImage = __webpack_require__(87522);
;// CONCATENATED MODULE: ./src/components/atom/icon/f2f/Check.tsx


var Check = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_5947_114674",
                "mask-type": "alpha",
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "32",
                height: "32",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    width: "32",
                    height: "32",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_5947_114674)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12.7333 20.2L24.0333 8.9C24.2999 8.63333 24.6166 8.5 24.9833 8.5C25.35 8.5 25.6666 8.63333 25.9333 8.9C26.1999 9.16667 26.3333 9.48333 26.3333 9.85C26.3333 10.2167 26.1999 10.5333 25.9333 10.8L13.6666 23.0667C13.4 23.3333 13.0888 23.4667 12.7333 23.4667C12.3777 23.4667 12.0666 23.3333 11.8 23.0667L6.06662 17.3333C5.79995 17.0667 5.67217 16.75 5.68328 16.3833C5.69439 16.0167 5.83328 15.7 6.09995 15.4333C6.36662 15.1667 6.68328 15.0333 7.04995 15.0333C7.41662 15.0333 7.73328 15.1667 7.99995 15.4333L12.7333 20.2Z",
                    fill: "#FF8D00"
                })
            })
        ]
    });
};
/* harmony default export */ var f2f_Check = (Check);

// EXTERNAL MODULE: ./src/components/templates/f2f/common/floating-bottom-sheet/index.tsx
var floating_bottom_sheet = __webpack_require__(3195);
;// CONCATENATED MODULE: ./src/components/templates/f2f/hospital/hospitals-influenza-template/free-influenza-bottom-sheet/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 328px;\n  padding: 12px 0 16px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n    margin-bottom: 8px;\n    padding: 0 24px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    & > span {\n      ",
        "\n      color: ",
        ";\n    }\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 56px;\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





var FreeInfluenzaBottomSheet = function(param) {
    var freeInfluenzaFilters = param.freeInfluenzaFilters, selectedFreeInfluenzaFilter = param.selectedFreeInfluenzaFilter, onClickFilter = param.onClickFilter, closeBottomSheet = param.closeBottomSheet;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(floating_bottom_sheet/* default */.Z, {
        index: 700,
        isOpened: true,
        onClickOverlay: closeBottomSheet,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                    children: "무료 접종만 보시겠어요?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InfluenzaFreeList, {
                    children: freeInfluenzaFilters.map(function(freeInfluenzaFilter) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FreeInfluenzaItem, {
                            onClick: function() {
                                return onClickFilter(freeInfluenzaFilter);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: freeInfluenzaFilter.getTitle()
                                }),
                                freeInfluenzaFilter.isSelected(selectedFreeInfluenzaFilter.type) && /*#__PURE__*/ (0,jsx_runtime.jsx)(f2f_Check, {})
                            ]
                        }, "freeInfluenza-".concat(freeInfluenzaFilter.getTitle()));
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var free_influenza_bottom_sheet = (FreeInfluenzaBottomSheet);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8c9f76cc-0"
})(_templateObject());
var Title = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-8c9f76cc-1"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), theme.typography.UI20SB, theme.color.gray800);
});
var InfluenzaFreeList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-8c9f76cc-2"
})(_templateObject3());
var FreeInfluenzaItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-8c9f76cc-3"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject4(), theme.typography.UI16M, theme.color.gray700);
});

// EXTERNAL MODULE: ../../node_modules/@tippyjs/react/dist/tippy-react.esm.js + 55 modules
var tippy_react_esm = __webpack_require__(39721);
// EXTERNAL MODULE: ./src/components/atom/buttons/DefaultButton.tsx
var DefaultButton = __webpack_require__(47641);
// EXTERNAL MODULE: ./src/components/atom/icon/arrow/HeaderCaret.tsx
var HeaderCaret = __webpack_require__(68584);
// EXTERNAL MODULE: ./src/components/atom/icon/arrow/NarrowCaret.tsx
var NarrowCaret = __webpack_require__(12469);
// EXTERNAL MODULE: ./src/components/molecules/app-header/styles.tsx
var styles = __webpack_require__(37237);
;// CONCATENATED MODULE: ./src/components/templates/f2f/hospital/hospitals-influenza-template/header/index.tsx

function header_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 200;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  width: 100%;\n  ",
        ";\n"
    ]);
    header_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function header_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  padding: 5px 7px;\n  & > span {\n    ",
        "\n  }\n"
    ]);
    header_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function header_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n\n  svg {\n    margin-left: 8px;\n  }\n"
    ]);
    header_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function header_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 6px;\n  border: none;\n  border-radius: 4px;\n\n  &:active {\n    background-color: ",
        ";\n  }\n"
    ]);
    header_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}










var Header = function(param) {
    var children = param.children, color = param.color, left = param.left, onClickOpenLocationBottomSheet = param.onClickOpenLocationBottomSheet, getHeaderAddress = param.getHeaderAddress;
    var timer;
    var address = getHeaderAddress();
    (0,react.useEffect)(function() {
        return function() {
            if (!timer) return;
            clearTimeout(timer);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        id: "appHeader",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* AppHeaderWrapper */.SL, {
                color: color,
                left: left,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* AppHeaderLeftButtons */.CF, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowWrapper, {
                            onClick: RNPlugins/* historyBack */.$i,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderCaret/* default */.Z, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Title */.Dx, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tippy_react_esm/* default */.ZP, {
                            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipContent, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "찾으시는 위치가 맞나요?"
                                })
                            }),
                            arrow: true,
                            offset: [
                                0,
                                20
                            ],
                            placement: "bottom",
                            popperOptions: {
                                strategy: "fixed"
                            },
                            zIndex: 201,
                            showOnCreate: true,
                            onCreate: function(param) {
                                var hide = param.hide;
                                timer = setTimeout(function() {
                                    hide();
                                }, 3000);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderWrapper, {
                                onClick: onClickOpenLocationBottomSheet,
                                children: [
                                    address,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NarrowCaret/* default */.Z, {
                                        direction: types_common/* DIRECTION.BOTTOM */.JR.BOTTOM
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* AppHeaderExtendedWrapper */.vV, {
                children: children
            })
        ]
    });
};
/* harmony default export */ var header = (Header);
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-97802eae-0"
})(header_templateObject(), function(param) {
    var theme = param.theme;
    return "\n      position: sticky;\n      background-color: ".concat(theme.color.white, ";\n      top: 0;\n    ");
});
var TooltipContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-97802eae-1"
})(header_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n      ".concat(theme.typography.UI14R, "\n      color: ").concat(theme.color.white, ";\n    ");
});
var HeaderWrapper = (0,styled_components_browser_esm/* default */.ZP)(DefaultButton/* DefaultButtonStyled */.qY).withConfig({
    componentId: "sc-97802eae-2"
})(header_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI18SB, ";\n  ");
});
var ArrowWrapper = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-97802eae-3"
})(header_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.color.gray50;
});

// EXTERNAL MODULE: ./src/components/atom/icon/IconLocationPinMono.tsx
var IconLocationPinMono = __webpack_require__(94781);
;// CONCATENATED MODULE: ./src/components/atom/icon/hospitals/influenza/LocalOffer.tsx

var LocalOffer = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M12.4892 6.755L7.23919 1.505C7.02919 1.295 6.73752 1.16666 6.41669 1.16666H2.33335C1.69169 1.16666 1.16669 1.69166 1.16669 2.33333V6.41666C1.16669 6.7375 1.29502 7.02916 1.51085 7.245L6.76085 12.495C6.97085 12.705 7.26252 12.8333 7.58335 12.8333C7.90419 12.8333 8.19585 12.705 8.40585 12.4892L12.4892 8.40583C12.705 8.19583 12.8334 7.90416 12.8334 7.58333C12.8334 7.2625 12.6992 6.965 12.4892 6.755ZM3.20835 4.08333C2.72419 4.08333 2.33335 3.6925 2.33335 3.20833C2.33335 2.72416 2.72419 2.33333 3.20835 2.33333C3.69252 2.33333 4.08335 2.72416 4.08335 3.20833C4.08335 3.6925 3.69252 4.08333 3.20835 4.08333Z",
            fill: "#F76707"
        })
    });
};
/* harmony default export */ var influenza_LocalOffer = (LocalOffer);

;// CONCATENATED MODULE: ./src/components/templates/f2f/hospital/hospitals-influenza-template/hospital/index.tsx

function hospital_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px 12px 0;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    hospital_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function hospital_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    hospital_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function hospital_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    hospital_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function hospital_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: column;\n\n  & > h3 {\n    ",
        "\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    word-break: break-all;\n    margin-bottom: 8px;\n  }\n"
    ]);
    hospital_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function hospital_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    hospital_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function hospital_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  white-space: nowrap;\n  align-items: center;\n"
    ]);
    hospital_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  margin-left: 4px;\n  margin-right: 6px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  flex: 1;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  word-break: break-all;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  margin-top: 12px;\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  display: inline-block;\n  padding: 1px 4px;\n  border-radius: 4px;\n  height: 20px;\n  margin-right: 4px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 2px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  align-self: stretch;\n  margin-top: 6px;\n  flex: 1;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  word-break: break-all;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  max-width: 64px;\n  max-height: 64px;\n  width: 100%;\n  height: 100%;\n  margin-left: 16px;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  height: 18px;\n  margin-bottom: 6px;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 6px;\n  height: 6px;\n  border-radius: 3px;\n  background-color: ",
        ";\n  margin-right: 4px;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          ",
        "\n          color: ",
        ";\n        "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          ",
        "\n          color: ",
        ";\n        "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          ",
        "\n          color: ",
        ";\n        "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          ",
        "\n          color: ",
        ";\n        "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 1px;\n  background-color: ",
        ";\n  margin-top: 20px;\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}








var Hospital = function(param) {
    var name = param.name, distance = param.distance, address = param.address, badges = param.badges, _isBookable = param.isBookable, isBookable = _isBookable === void 0 ? false : _isBookable, diagnosisPrice = param.diagnosisPrice, imageUrl = param.imageUrl, badgeLabelList = param.badgeLabelList, status = param.status;
    var visibleBadgeList = badges.slice(0, 3);
    var hasMoreBadge = badges.length > visibleBadgeList.length;
    var moreBadgeLength = badges.length - visibleBadgeList.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(hospital_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HospitalWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DiagnosisStatus, {
                                type: status
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleRow, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HospitalName, {
                                    children: name
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoWrapper, {
                                children: [
                                    !!distance && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconLocationPinMono/* default */.Z, {
                                                fill: theme/* default.color.gray300 */.Z.color.gray300
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Distance, {
                                                children: (0,format/* formatKilometerByMeter */.ox)(distance)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Address, {
                                        children: address
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceWrapper, {
                                children: [
                                    !!diagnosisPrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Price, {
                                        children: [
                                            (0,format/* getCurrencyFormat */.mo)(diagnosisPrice),
                                            "원"
                                        ]
                                    }),
                                    !!badgeLabelList && (badgeLabelList === null || badgeLabelList === void 0 ? void 0 : badgeLabelList.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceBadgeWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(influenza_LocalOffer, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceBadge, {
                                                children: badgeLabelList === null || badgeLabelList === void 0 ? void 0 : badgeLabelList.join("")
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctornowImage/* default */.Z, {
                            className: "rounded-[8px]",
                            objectFit: "cover",
                            src: imageUrl,
                            width: 64,
                            height: 64,
                            alt: name,
                            loading: "lazy"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BadgeWrapper, {
                hasItem: badges.length > 0,
                children: [
                    isBookable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BookableBadge, {
                        children: "간편예약"
                    }, "badge-".concat(name, "-bookable")) : /*#__PURE__*/ (0,jsx_runtime.jsx)(UnBookableBadge, {
                        children: "전화예약"
                    }, "badge-".concat(name, "-").concat(name, "-unbookable")),
                    visibleBadgeList.map(function(badge, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                            children: badge
                        }, "badge-".concat(name, "-").concat(badge, "-").concat(i));
                    }),
                    hasMoreBadge && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Badge, {
                        children: [
                            "+",
                            moreBadgeLength
                        ]
                    }, "badge-".concat(name, "-+"))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BorderLine, {})
        ]
    });
};
/* harmony default export */ var hospitals_influenza_template_hospital = (Hospital);
var DiagnosisStatus = function(props) {
    var text = (0,format/* getDiagnosisStateText */.QN)(props.type);
    switch(props.type){
        case hospital/* DiagnosisState.On */.J0.On:
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StatusWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusOn, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusText, {
                        type: props.type,
                        children: text
                    })
                ]
            });
        case hospital/* DiagnosisState.Off */.J0.Off:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusDisabledText, {
                    type: props.type,
                    children: text
                })
            });
        case hospital/* DiagnosisState.Lunch */.J0.Lunch:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusText, {
                    type: props.type,
                    children: text
                })
            });
        case hospital/* DiagnosisState.DayOff */.J0.DayOff:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusText, {
                    type: props.type,
                    children: text
                })
            });
        case hospital/* DiagnosisState.Unknown */.J0.Unknown:
            return null;
    }
};
var hospital_Wrapper = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-14935ef5-0"
})(hospital_templateObject());
var HospitalName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-14935ef5-1"
})(hospital_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n          ".concat(theme.typography.UI15SB, "\n          color: ").concat(theme.color.gray600, ";\n      ");
});
var TopWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-14935ef5-2"
})(hospital_templateObject2());
var HospitalWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-14935ef5-3"
})(hospital_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n          ".concat(theme.typography.UI17SB, "\n          color: ").concat(theme.color.gray600, ";\n      ");
});
var TitleRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-14935ef5-4"
})(hospital_templateObject4());
var InfoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-14935ef5-5"
})(hospital_templateObject5());
var Distance = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-14935ef5-6"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI13M, "\n    color: ").concat(theme.color.gray600, ";\n  ");
});
var Address = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-14935ef5-7"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return "\n        ".concat(theme.typography.UI13M, "\n        color: ").concat(theme.color.gray300, ";\n    ");
});
var BadgeWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-14935ef5-8"
})(_templateObject8(), function(param) {
    var hasItem = param.hasItem;
    return hasItem ? "block" : "none";
}, function(param) {
    var theme = param.theme;
    return "\n      ".concat(theme.typography.UI12M, "\n      color: ").concat(theme.color.gray300, ";\n      ");
});
var Badge = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-14935ef5-9"
})(_templateObject9(), function(param) {
    var theme = param.theme;
    return "\n      ".concat(theme.typography.UI12M, "\n      color: ").concat(theme.color.gray300, ";\n      background: ").concat(theme.color.gray30, ";\n      ");
});
var BookableBadge = (0,styled_components_browser_esm/* default */.ZP)(Badge).withConfig({
    componentId: "sc-14935ef5-10"
})(_templateObject10(), function(param) {
    var theme = param.theme;
    return "\n      color: ".concat(theme.color.primary700, ";\n      background: ").concat(theme.color.primary100, ";\n      ");
});
var UnBookableBadge = (0,styled_components_browser_esm/* default */.ZP)(Badge).withConfig({
    componentId: "sc-14935ef5-11"
})(_templateObject11(), function(param) {
    var theme = param.theme;
    return "\n      color: ".concat(theme.color.gray500, ";\n      background: ").concat(theme.color.gray50, ";\n\n      ");
});
var PriceBadgeWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-14935ef5-12"
})(_templateObject12());
var PriceWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-14935ef5-13"
})(_templateObject13());
var Price = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-14935ef5-14"
})(_templateObject14(), function(param) {
    var theme = param.theme;
    return "\n".concat(theme.typography.UI18SB, "\ncolor: ").concat(theme.color.gray700, ";\nmargin-right: 6px;\n");
});
var PriceBadge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-14935ef5-15"
})(_templateObject15(), function(param) {
    var theme = param.theme;
    return "\n".concat(theme.typography.UI12SB, "\ncolor: ").concat(theme.color.primary700, ";\n");
});
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-14935ef5-16"
})(_templateObject16());
var StatusWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-14935ef5-17"
})(_templateObject17());
var StatusOn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-14935ef5-18"
})(_templateObject18(), function(param) {
    var theme = param.theme;
    return theme.color.green500;
});
var StatusText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-14935ef5-19"
})(_templateObject23(), function(param) {
    var theme = param.theme, type = param.type;
    switch(type){
        case hospital/* DiagnosisState.On */.J0.On:
            {
                return (0,styled_components_browser_esm/* css */.iv)(_templateObject19(), theme.typography.UI12R, theme.color.green700);
            }
        case hospital/* DiagnosisState.Lunch */.J0.Lunch:
            {
                return (0,styled_components_browser_esm/* css */.iv)(_templateObject20(), theme.typography.UI12R, theme.color.gray300);
            }
        case hospital/* DiagnosisState.Off */.J0.Off:
            {
                return (0,styled_components_browser_esm/* css */.iv)(_templateObject21(), theme.typography.UI12R, theme.color.gray300);
            }
        case hospital/* DiagnosisState.DayOff */.J0.DayOff:
            {
                return (0,styled_components_browser_esm/* css */.iv)(_templateObject22(), theme.typography.UI12R, theme.color.gray300);
            }
        case hospital/* DiagnosisState.Unknown */.J0.Unknown:
            {
                return "";
            }
    }
});
var StatusDisabledText = (0,styled_components_browser_esm/* default */.ZP)(StatusText).withConfig({
    componentId: "sc-14935ef5-20"
})(_templateObject24(), function(param) {
    var theme = param.theme;
    return "\n        color: ".concat(theme.color.gray200, ";\n    ");
});
var BorderLine = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-14935ef5-21"
})(_templateObject25(), function(param) {
    var theme = param.theme;
    return theme.color.gray40;
});

// EXTERNAL MODULE: ./src/types/app.ts
var app = __webpack_require__(9912);
;// CONCATENATED MODULE: ./src/components/templates/f2f/hospital/hospitals-influenza-template/influenza-filters/index.tsx

function influenza_filters_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: sticky;\n  top: ",
        "px;\n  background-color: ",
        ";\n  display: flex;\n  overflow-x: scroll;\n  white-space: nowrap;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 24px 12px 0;\n  margin-left: 24px;\n"
    ]);
    influenza_filters_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function influenza_filters_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0 12px;\n    border-radius: 40px;\n    height: 36px;\n    background: ",
        ";\n    border: 1px solid\n      ",
        ";\n    & > span {\n      ",
        "\n      color: ",
        ";\n    }\n    & > * + * {\n      margin-left: 2px;\n    }\n    & path {\n      fill: ",
        ";\n    }\n  "
    ]);
    influenza_filters_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function influenza_filters_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    influenza_filters_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function influenza_filters_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    padding: 0 12px;\n    border-radius: 40px;\n    height: 36px;\n    background: ",
        ";\n    border: 1px solid ",
        ";\n  "
    ]);
    influenza_filters_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function influenza_filters_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    influenza_filters_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var InfluenzaFilters = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(influenza_filters_Wrapper, {
        children: children
    });
};
var Filter = function(param) {
    var children = param.children, onClick = param.onClick, isSelected = param.isSelected;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterWrapper, {
        isSelected: isSelected,
        onClick: onClick,
        children: children
    });
};
var influenza_filters_Refresh = function(param) {
    var children = param.children, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RefreshWrapper, {
        onClick: onClick,
        children: children
    });
};
/* harmony default export */ var influenza_filters = (InfluenzaFilters);
InfluenzaFilters.Filter = Filter;
InfluenzaFilters.Refresh = influenza_filters_Refresh;
var influenza_filters_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a680b49f-0"
})(influenza_filters_templateObject(), function(param) {
    var theme = param.theme;
    return theme.client.clientType === app/* ClientType.MOBILE_WEB */.B.MOBILE_WEB ? 120 : 60;
}, function(param) {
    var theme = param.theme;
    return theme.color.white;
});
var FilterWrapper = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-a680b49f-1"
})(influenza_filters_templateObject2(), function(param) {
    var theme = param.theme, isSelected = param.isSelected;
    return (0,styled_components_browser_esm/* css */.iv)(influenza_filters_templateObject1(), isSelected ? theme.color.primary100 : theme.color.gray30, isSelected ? theme.color.primary600 : theme.color.gray30, theme.typography.UI14R, isSelected ? theme.color.primary700 : theme.color.gray700, isSelected ? theme.color.primary700 : theme.color.gray700);
});
var RefreshWrapper = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-a680b49f-2"
})(influenza_filters_templateObject4(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(influenza_filters_templateObject3(), theme.color.gray30, theme.color.gray30);
});

;// CONCATENATED MODULE: ./src/components/templates/f2f/hospital/hospitals-influenza-template/index.tsx


function hospitals_influenza_template_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transform: rotate(90deg);\n"
    ]);
    hospitals_influenza_template_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
























var HospitalsInfluenzaTemplate = function(param) {
    var client = param.client;
    (0,useSetAuthOnScreenFocus/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var pageName = (0,logger/* getMobileWebPageName */.b9)(router);
    var viewModel = list_useInfluenzaHospitalListViewModel();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.Header */.Z.Header, {
                useSafeArea: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header, {
                    onClickOpenLocationBottomSheet: viewModel.switchRegionFilter,
                    getHeaderAddress: viewModel.getHeaderAddress
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Content */.Z.Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(influenza_filters, {
                        children: [
                            viewModel.isInfluenzaFiltersSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)(influenza_filters.Refresh, {
                                onClick: viewModel.resetInfluenzaFilters,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Refresh/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(influenza_filters.Filter, {
                                isSelected: viewModel.isFreeInfluenzaFilterSelected,
                                onClick: function() {
                                    return viewModel.toggleInfluenzaFilter(hospital/* HospitalInfluenzaFilter.FreeInfluenza */.rT.FreeInfluenza)();
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: viewModel.selectedInfluenzaFilters.FreeInfluenza.getTitle()
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RotationIcon, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                            name: "chevron_right",
                                            size: 16,
                                            color: theme/* default.color.gray700 */.Z.color.gray700
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(hospital_list/* default */.Z, {
                        isLoading: viewModel.isLoadingHospitals,
                        hasHospitals: !!viewModel.hospitals.length,
                        fetchNextPage: viewModel.fetchNextPage,
                        hasNextPage: viewModel.hasNextPage,
                        style: {
                            padding: "0 12px"
                        },
                        children: viewModel.hospitals.map(function(hospital, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(link_tag/* default */.Z, {
                                onClickNavigateToScreen: function() {
                                    return viewModel.goToAppHospital(hospital.hospitalPublicId);
                                },
                                href: "".concat(types_common/* ROUTES.HOSPITAL.DETAIL.path */.Z6.HOSPITAL.DETAIL.path).concat(hospital.hospitalPublicId, "?type=influenza"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickEventLogger/* default */.Z, {
                                    pageName: pageName,
                                    eventName: "click_hospital",
                                    payload: {
                                        section: "quick_search",
                                        position: i,
                                        hospital_id: hospital.hospitalPublicId,
                                        status: (0,format/* getDiagnosisStateText */.QN)(hospital.hospitalOperationStatus)
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(hospitals_influenza_template_hospital, {
                                        name: hospital.hospitalName,
                                        distance: hospital.hospitalDistance,
                                        badges: hospital.hospitalBadges,
                                        address: hospital.hospitalAddress,
                                        isBookable: hospital.isBookable,
                                        representativeDepartmentName: hospital.hospitalRepresentativeDepartmentName,
                                        diagnosisPrice: hospital.nonBenefit.diagnosisPrice,
                                        badgeLabelList: hospital.nonBenefit.labels,
                                        imageUrl: hospital.hospitalRepresentativeImageUrl,
                                        status: hospital.hospitalOperationStatus
                                    })
                                })
                            }, "reservable_hospital_".concat(hospital.hospitalPublicId));
                        })
                    }),
                    !viewModel.isLoadingHospitals && viewModel.hospitals.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(empty_notice/* default */.Z, {
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctornowImage/* default */.Z, {
                            width: 40,
                            height: 40,
                            src: "/images/3dGraphics/CryingFace@3x.png",
                            alt: "우는 얼굴"
                        }),
                        text: "찾으시는 병원이 없어요",
                        useButton: false
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sticky_move_top_button/* default */.Z, {}),
                    viewModel.isRegionFilterOpened && /*#__PURE__*/ (0,jsx_runtime.jsx)(hospital_region_filter_modal/* default */.Z, {
                        client: client,
                        switchRegionFilter: viewModel.switchRegionFilter,
                        addresses: viewModel.addresses,
                        selectSavedAddress: viewModel.selectSavedAddress,
                        goToAppMyPageAddressScreen: viewModel.goToAppMyPageAddressScreen,
                        siDoList: viewModel.siDoList,
                        siGunGuList: viewModel.siGunGuList,
                        dongList: viewModel.dongList,
                        selectedRegion: viewModel.selectedRegion,
                        getCurrentLocation: viewModel.getCurrentLocation,
                        clickSiDo: viewModel.clickSiDo,
                        clickSiGunGu: viewModel.clickSiGunGu,
                        clickDong: viewModel.clickDong,
                        isOpened: viewModel.isRegionFilterOpened,
                        isSejong: viewModel.isSejong
                    }),
                    viewModel.isInfluenzaFiltersOpen.FreeInfluenza && /*#__PURE__*/ (0,jsx_runtime.jsx)(free_influenza_bottom_sheet, (0,_object_spread/* default */.Z)({}, viewModel.getFreeInfluenzaFiltersProps()))
                ]
            })
        ]
    });
};
/* harmony default export */ var hospitals_influenza_template = (HospitalsInfluenzaTemplate);
var RotationIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d22e8aa2-0"
})(hospitals_influenza_template_templateObject());

;// CONCATENATED MODULE: ./src/pages/hospitals/influenza/index.tsx
// PageDescription: 대면진료 독감예방접종 병원 리스트 페이지










var cutCityNames = [
    "서울",
    "부산",
    "대구",
    "인천",
    "광주",
    "대전",
    "울산",
    "세종",
    "제주"
];
var HospitalsInfluenzaSeo = function(param) {
    var queries = param.queries;
    var siDoName = queries.siDoName, siGunGuName = queries.siGunGuName;
    var ref;
    var cuttedName = (ref = siDoName === null || siDoName === void 0 ? void 0 : siDoName.slice(0, 2)) !== null && ref !== void 0 ? ref : "";
    var hospitals = list_useInfluenzaHospitalListViewModel().hospitals;
    var hospitalJson = (0,format/* createSearchHospitalLdJson */.M)(hospitals);
    var isDefaultSeo = function() {
        return !siDoName;
    };
    var isSeongnamSeo = function() {
        return siGunGuName === null || siGunGuName === void 0 ? void 0 : siGunGuName.includes("성남시");
    };
    var isSejong = function() {
        return siDoName === null || siDoName === void 0 ? void 0 : siDoName.includes("세종");
    };
    var isCutSidoName = function() {
        return cutCityNames.includes(cuttedName);
    };
    var getCityTitle = function() {
        if (isSejong()) {
            return cuttedName;
        }
        if (isCutSidoName()) {
            return "".concat(cuttedName, " ").concat(siGunGuName);
        }
        return "".concat(siGunGuName);
    };
    var cityTitle = getCityTitle();
    if (isDefaultSeo()) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
            title: "독감예방접종 병원찾기 - 닥터나우",
            description: "내 근처 무료 독감주사 접종 병원 찾고, 가격 비교부터 원하는 시기 예약까지 한 번에 할 수 있어요",
            canonical: "".concat("https://doctornow.co.kr").concat(types_common/* ROUTES.HOSPITAL.INFLUENZA.path */.Z6.HOSPITAL.INFLUENZA.path),
            openGraph: {
                title: "독감예방접종 병원찾기 - 닥터나우",
                description: "독감주사 병원 위치, 가격 확인 후 예약까지 해보세요!",
                images: [
                    {
                        url: "".concat("https://media.doctornow.co.kr/james_influenza_OG.png"),
                        alt: "Og Image Alt"
                    }, 
                ]
            }
        });
    }
    if (isSeongnamSeo()) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(hospitalJson)
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                    title: "성남시 독감예방무료접종 병원찾기(2023) - 닥터나우",
                    description: "성남 시민이라면 무료로 독감주사를 맞을 수 있어요. 인플루엔자(독감) 4가 백신 부담없이 무료로 원하는 시기에 예약하고 접종해 보세요!",
                    canonical: "".concat("https://doctornow.co.kr").concat(types_common/* ROUTES.HOSPITAL.INFLUENZA.path */.Z6.HOSPITAL.INFLUENZA.path).concat(siDoName ? "?siDoName=".concat(siDoName) : "").concat(siGunGuName ? "&siGunGuName=".concat(siGunGuName) : ""),
                    openGraph: {
                        title: "성남시 독감예방무료접종 병원찾기(2023) - 닥터나우",
                        description: "성남 시민이라면 무료로 예방접종 가능! 지금 예약하고 접종해 보세요!",
                        images: [
                            {
                                url: "".concat("https://media.doctornow.co.kr/james_influenza_OG.png"),
                                alt: "Og Image Alt"
                            }, 
                        ]
                    }
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(hospitalJson)
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "".concat(cityTitle, " 독감예방접종 병원찾기 - 닥터나우"),
                description: "".concat(cityTitle, " 근처 무료 독감주사 접종 병원 찾고, 가격 비교부터 원하는 시기 예약까지 한 번에 할 수 있어요"),
                canonical: "".concat("https://doctornow.co.kr").concat(types_common/* ROUTES.HOSPITAL.INFLUENZA.path */.Z6.HOSPITAL.INFLUENZA.path).concat(siDoName ? "?siDoName=".concat(siDoName) : "").concat(siGunGuName ? "&siGunGuName=".concat(siGunGuName) : ""),
                openGraph: {
                    title: "".concat(cityTitle, " 독감예방접종 병원찾기 - 닥터나우"),
                    description: "독감주사 병원 위치, 가격 확인 후 예약까지 해보세요!",
                    images: [
                        {
                            url: "".concat("https://media.doctornow.co.kr/james_influenza_OG.png"),
                            alt: "Og Image Alt"
                        }, 
                    ]
                }
            })
        ]
    });
};
var HospitalsInfluenzaListPage = function(param) {
    var client = param.client, queries = param.queries;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HospitalsInfluenzaSeo, {
                queries: queries
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hospitals_influenza_template, {
                client: client
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var influenza = (HospitalsInfluenzaListPage);
HospitalsInfluenzaListPage.Layout = DefaultLayout/* default */.Z;


/***/ }),

/***/ 3818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KL": function() { return /* binding */ userState; }
/* harmony export */ });
/* unused harmony exports getUserState, setUserState */
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53476);
/* harmony import */ var recoil_nexus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89430);
/* harmony import */ var recoil_persist__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6983);



var persistAtom = (0,recoil_persist__WEBPACK_IMPORTED_MODULE_2__/* .recoilPersist */ .J)().persistAtom;
var userState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "userState",
    default: {},
    effects_UNSTABLE: [
        persistAtom
    ]
});
var getUserState = function() {
    return getRecoil(userState);
};
var setUserState = function(userData) {
    setRecoil(userState, userData);
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5214,9916,9653,8185,5964,9332,9774,2888,179], function() { return __webpack_exec__(50445); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);